import { createElementVNode as _createElementVNode, openBlock as _openBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative contact-container min-h-screen min-w-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute inset-0 -z-10 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("pattern", {
      id: "0787a7c5-978c-4f66-83c7-11c213f99cb7",
      width: "200",
      height: "200",
      x: "50%",
      y: "-1",
      patternUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M.5 200V.5H200",
        fill: "none"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "100%",
    height: "100%",
    "stroke-width": "0",
    fill: "url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
  })
], -1)
const _hoisted_3 = { class: "flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "mt-10 sm:mx-auto lg:mt-60 sm:w-full sm:max-w-[480px]" }
const _hoisted_5 = {
  class: "bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12",
  "data-aos": "fade-up"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Email", -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Name", -1)
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "text",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Description", -1)
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "col-span-full" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "about",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Message", -1)
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-sm leading-6 text-gray-600" }, "Write a Message.", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
  }, "Send")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            class: "space-y-6"
          }, [
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  id: "email",
                  name: "email",
                  type: "email",
                  autocomplete: "email",
                  class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                    id: "name",
                    name: "name",
                    type: "text",
                    autocomplete: "name",
                    class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  }, null, 512), [
                    [_vModelText, _ctx.name]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                  id: "text",
                  name: "description",
                  type: "text",
                  autocomplete: "current-password",
                  class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                }, null, 512), [
                  [_vModelText, _ctx.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
                  id: "about",
                  name: "about",
                  rows: "3",
                  class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                }, null, 512), [
                  [_vModelText, _ctx.message]
                ])
              ]),
              _hoisted_15
            ]),
            _hoisted_16,
            (_ctx.notification.show)
              ? (_openBlock(), _createBlock(_component_Notification, {
                  key: 0,
                  message: _ctx.notification.message,
                  success: _ctx.notification.success,
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.notification.show = false))
                }, null, 8, ["message", "success"]))
              : _createCommentVNode("", true),
            _createTextVNode(" to "),
            (_ctx.notification.show)
              ? (_openBlock(), _createBlock(_component_Notification, {
                  key: 1,
                  message: _ctx.notification.message,
                  success: _ctx.notification.success,
                  onClose: _cache[5] || (_cache[5] = () => _ctx.notification.show = false)
                }, null, 8, ["message", "success"]))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ])
  ]))
}